import React from "react";
import { Text, Flex, Box } from "@chakra-ui/react"
import { Link } from "react-router-dom";


const Footer = () => {
    return(
        <Flex flexDir="column" justifyContent="center" textAlign="center" p="1rem .75rem" color="white" bg="#111" opacity=".9" fontSize="12px" mt="1.875rem">
            <Text mb="10px"> VisioJob, société inscrite au RCS Paris n° 123456789 – Capital : 1 000,00€ – 1 RUE D ENGHIEN 75010 PARIS - FRANCE </Text>
            <Flex flexDir="row" flexWrap="wrap" justifyContent="center" fontSize="11px" maxWidth="453px" mx="auto">
                <Text opacity=".75" fontWeight="normal" m="0 16px"> Tous droits réservés - VisioJob 2020 </Text>
                <a href="https://www.visiojob.fr/legal/terms"> 
                    <Box opacity=".75" fontWeight="600" _hover={{ textDecor: "underline" }}> Conditions générales d’utilisation </Box> 
                </a>
            </Flex>
        </Flex>
    )
}

export default Footer;